import React from "react";
import { mergeWith } from "lodash";
import { QREventProps } from "./types";
import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";
import { QREditorContext } from "@/contexts/QREditorContext";
import { applyQRFormDefaultValues, onBindClick } from "@/utils/formHelper";
import { omittedValues, onBindImage, onBindThemePicker } from "@/utils/qrEditorHelper";
import { Typography } from "@/components/Typography";
import { Form } from "@/components/Form";
import { qrEventValidation } from "@/utils/validators/qr-event";
import { Icon_Facility } from "@/types/qr";
import { NAMESPACES } from "@/internals/constants/namespaces";
import { useTranslation } from "react-i18next";

import "./styles.scss";

export const QREvent = ({ data }: QREventProps) => {
  const { t } = useTranslation(NAMESPACES.VALIDATIONS);
  const { qrData, setQrData } = React.useContext<QREditorContextProps<"event">>(QREditorContext);

  const [qrEventData, setQrEventData] = React.useState<QRProps<"event">>(qrData);
  const [renderForm, setRenderForm] = React.useState(false);

  const dataEventWithDefaultValues = applyQRFormDefaultValues(data, qrData.data);

  const onUpdateState = ({ field, value }) => {
    if (field === "timeActionTitle" || field == "") return;

    return setQrData(
      {
        ...qrData,
        data: {
          ...qrData.data,
          [field]: value,
        },
      },
      [...omittedValues(qrData.data)]
    );
  };

  onBindImage(dataEventWithDefaultValues, "qrEventInformationImage", omittedValues(qrData.data));

  onBindThemePicker(dataEventWithDefaultValues, "qrEventThemePicker", omittedValues(qrData.data));

  onBindClick(
    dataEventWithDefaultValues,
    "qrEventFacilitiesPicker",
    (selectedOptions: Icon_Facility[]) =>
      setQrData(
        {
          ...qrData,
          data: { ...qrData.data, facilities: selectedOptions },
        },
        omittedValues(qrData.data)
      )
  );

  onBindClick(dataEventWithDefaultValues, "eventDateTime", (dateTimeData = {}) => {
    const originalEventDateTime = qrData?.data?.eventDateTime || {};
    const merged = mergeWith(originalEventDateTime, dateTimeData);

    return setQrData(
      {
        ...qrData,
        data: {
          ...qrData.data,
          eventDateTime: merged,
        },
      },
      omittedValues(qrData.data)
    );
  });

  React.useEffect(() => {
    setQrEventData(qrData);
  }, [qrData]);

  React.useEffect(() => {
    setQrData({ ...qrEventData, isValidForm: renderForm });
  }, [renderForm]);

  return (
    <div className="qr-event">
      <Typography
        Tag="p"
        size="l"
        classname="u-bold u-spacing-5"
      >
        {data.title}
      </Typography>
      <Form
        fields={dataEventWithDefaultValues}
        schema={qrEventValidation(data, t)}
        onWatchFields={({ field, value }) => onUpdateState({ field, value })}
        isFormValid={(isValidForm) => {
          setRenderForm(isValidForm);
        }}
      />
    </div>
  );
};
